import React from "react";
import { Link } from "react-router-dom";
import { FaDiscord, FaEnvelope, FaYoutube, FaFacebook, FaInstagram } from "react-icons/fa";
import { DISCORD_URL } from "../data/siteCatalog";
import kyrosLogo from "../images/kyros_name.png";
import "../style/Footer.css";

const COPYRIGHT_YEAR = 2026;

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__columns">
          <div className="footer__column footer__column--brand">
            <img src={kyrosLogo} alt="Kyros Games logo" className="footer__logo" />
            <p>
              Videogame autoprodotti per Windows, Store Kyros e launcher ufficiale.
              Zombie Crushers è gratis, WarFront passa dallo Store, Ghost Hunter è in sviluppo.
            </p>
            <Link className="footer__cta" to="/contact">
              Contattaci
            </Link>
          </div>

          <div className="footer__column">
            <h3>Navigazione</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/games">Giochi</Link></li>
              <li><Link to="/store">Store</Link></li>
              <li><Link to="/account">Account</Link></li>
              <li><Link to="/contact">Contatti</Link></li>
            </ul>
          </div>

          <div className="footer__column">
            <h3>Giochi</h3>
            <ul>
              <li><Link to="/games/zombie-crushers">Zombie Crushers</Link></li>
              <li><Link to="/games/warfront">WarFront</Link></li>
              <li><Link to="/games/ghost-hunter">Ghost Hunter</Link></li>
              <li><Link to="/services">Piattaforma Kyros</Link></li>
              <li><Link to="/about">About Kyros</Link></li>
            </ul>
          </div>

          <div className="footer__column footer__column--contact">
            <h3>Supporto</h3>
            <ul>
              <li>
                <a href="mailto:support@kyrosgames.com">
                  <FaEnvelope aria-hidden="true" />
                  support@kyrosgames.com
                </a>
              </li>
              <li><Link to="/contact">Modulo contatti</Link></li>
              <li><Link to="/terms">Termini e rimborso</Link></li>
            </ul>
            <div className="footer__social">
              <span>Canali</span>
              <div className="footer__social-icons" aria-label="Canali Kyros">
                <a className="footer__social-link" href={DISCORD_URL} target="_blank" rel="noopener noreferrer" aria-label="Kyros Games su Discord"><FaDiscord aria-hidden="true" /></a>
                <a className="footer__social-link" href="https://www.facebook.com/profile.php?id=61582510980470" target="_blank" rel="noopener noreferrer" aria-label="Kyros Games su Facebook"><FaFacebook aria-hidden="true" /></a>
                <a className="footer__social-link" href="https://www.instagram.com/kyros_games/" target="_blank" rel="noopener noreferrer" aria-label="Kyros Games su Instagram"><FaInstagram aria-hidden="true" /></a>
                <a className="footer__social-link" href="https://www.youtube.com/@KyrosGamesOfficial" target="_blank" rel="noopener noreferrer" aria-label="Kyros Games su YouTube"><FaYoutube aria-hidden="true" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {COPYRIGHT_YEAR} Kyros Games. Tutti i diritti riservati.</span>
        <div className="footer__legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/cookie-policy">Cookie</Link>
          <Link to="/terms">Termini e rimborso</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
